module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$user.isNotActivated) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_c('i', {
    staticClass: "alert-icon far fa-exclamation-triangle"
  }), _vm._v("\n\t\t\tYour carrier account is pending verification from Arrow Logistics.\n\t\t")]) : _vm._e(), _vm._v(" "), (_vm.$user.isClient) ? _c('div', [(_vm.$user.isDisabled && _vm.haveUnpaidInvoices) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('i', {
    staticClass: "alert-icon far fa-exclamation-triangle"
  }), _vm._v("\n        This account is suspended, an invoice is 35 days overdue, please contact Arrow Logistics.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.haveUnpaidInvoices) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('i', {
    staticClass: "alert-icon far fa-exclamation-triangle"
  }), _vm._v("\n        This account has " + _vm._s(_vm.$user.unpaid_invoices_count) + " unpaid invoices.\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('widgets'), _vm._v(" "), (_vm.$user.isCarrier) ? _c('load-request-list') : _vm._e(), _vm._v(" "), (_vm.$user.isCarrier) ? _c('load-list') : _vm._e(), _vm._v(" "), (_vm.$user.isAdmin) ? _c('job-request-list') : _vm._e(), _vm._v(" "), _c('job-list'), _vm._v(" "), (_vm.$user.isClientOrCarrier) ? _c('invoice-list') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-f520327c"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = 1089
// module chunks = 0